const carTrust = {
  tabs: [
    { id: "overview", label: "Overview" },
    { id: "specifications", label: "Specifications" },
    { id: "features", label: "Features" },
    { id: "inspection", label: "Inspection" },
    { id: "warranty", label: "Warranty" },
  ],
  badges: {
    modified: "Modified",
    certified: "Certified",
    standard: "Standard",
    verified: "Verified",
  },
  overview: {
    highlights: [
      { key: "quality", title: "Quality Checked", description: "Inspected before listing" },
      { key: "verified", title: "Verified Listing", description: "Trusted CarsInfinite stock" },
      { key: "condition", modifiedTitle: "Modified", standardTitle: "Standard", modifiedDescription: "Premium build", standardDescription: "Original condition" },
    ],
    descriptionTitle: "About this vehicle",
    descriptionTemplate: "This {title} is listed on CarsInfinite with complete specifications, verified details, and direct dealer support. Ideal for buyers looking for a reliable {bodyType} with {fuelType} performance and {transmission} transmission.",
    videoTitle: "Video Tour",
    shortsTitle: "Quick Short",
    emptyFeatures: "No additional features listed for this vehicle.",
  },
  sidebar: {
    priceLabel: "Selling Price",
    viewsSuffix: "views",
    emiLabel: "Est. EMI",
    emiTenureLabel: "Approx. 60 months",
    emiCalculatorLabel: "Calculate EMI",
    emiCalculatorPath: "/finance",
    emiQueryParam: "price",
    warrantyPolicyLabel: "View Protection Policy",
    warrantyPolicyPath: "/warranty",
    locationLabel: "Location",
    missingLocation: "Not specified",
    requestCallLabel: "Request Call",
    whatsappLabel: "WhatsApp",
    bookTestDriveLabel: "Book Test Drive",
    mobileCallLabel: "Call",
    trustPoints: [
      "7-day buyer support on eligible cars",
      "Inspection report shared before visit",
      "Quick response via call or chat",
    ],
  },
  inspection: {
    title: "Inspection Report",
    subtitleTemplate: "{passed}/{total} points checked",
    pendingTitle: "Inspection pending",
    pendingMessage: "The inspection checklist is not published for this car yet.",
    lastInspectedLabel: "Last inspected",
    categoryScoreLabel: "{score}/{total}",
    overallScoreLabel: "Overall Inspection Score",
    overallScoreSuffix: "/ 100",
    scoreBreakdownTitle: "Category Score Breakdown",
    photoGalleryTitle: "Inspection Photos",
    photoGallerySubtitle: "Detailed photos from our quality check",
    noPhotosMessage: "Inspection photos are not uploaded for this car yet.",
    pdfLabel: "Download Full Report (PDF)",
    pdfUnavailable: "PDF report will be shared after inspection is complete.",
    scoreTiers: {
      excellent: { min: 90, label: "Excellent" },
      good: { min: 75, label: "Good" },
      fair: { min: 60, label: "Fair" },
      poor: { min: 0, label: "Needs Work" },
    },
    statusLabels: {
      pass: "Pass",
      warning: "Needs attention",
      fail: "Fail",
      pending: "Pending",
      unknown: "Not checked",
    },
    defaultCategories: [
      { key: "engine", title: "Engine" },
      { key: "transmission", title: "Transmission" },
      { key: "brakes", title: "Brakes" },
      { key: "tyres", title: "Tyres" },
      { key: "battery", title: "Battery" },
      { key: "ac", title: "AC" },
      { key: "electricals", title: "Electricals" },
      { key: "interior", title: "Interior" },
      { key: "exterior", title: "Exterior" },
      { key: "accident", title: "Accident History" },
      { key: "flood", title: "Flood Damage" },
      { key: "repaint", title: "Repainting" },
      { key: "service", title: "Service History" },
      { key: "documents", title: "Documents" },
    ],
  },
  warranty: {
    title: "Warranty & Return Policy",
    pendingTitle: "Warranty not attached",
    pendingMessage: "Warranty details are not published for this car yet.",
    packageLabel: "Package",
    supportDaysLabel: "{days}-day support policy",
    engineGearboxLabel: "Engine and gearbox warranty",
    returnEligibleLabel: "{days}-day return eligible",
    returnNotEligibleLabel: "Return eligibility only for certified stock",
    inclusionsTitle: "Included",
    exclusionsTitle: "Not Included",
    plansTitle: "Available Protection Plans",
    plansSubtitle: "Choose a plan when reserving this car",
    policyCtaLabel: "Read Full Policy",
    policyCtaPath: "/warranty",
    reserveCtaLabel: "Reserve with Protection",
    reserveLoginPath: "/login",
    returnWindowLabel: "Return window",
    returnWindowDaysTemplate: "{days} days from delivery",
    lifecycleTitle: "Order Lifecycle",
    lifecycleSubtitle: "Track your protection request through each stage",
  },
  testDrive: {
    title: "Book Test Drive",
    subtitle: "Pick a preferred date, time, and location. Our team will confirm the slot.",
    dateLabel: "Preferred Date",
    timeLabel: "Preferred Time",
    locationLabel: "Location",
    nameLabel: "Name",
    phoneLabel: "Phone",
    notesLabel: "Notes",
    reminderLabel: "Send me booking reminders",
    submitLabel: "Book Test Drive",
    submittingLabel: "Booking...",
    closeLabel: "Close",
    successTitle: "Test drive requested",
    successMessage: "Your booking request has been shared with our team.",
    errorTitle: "Booking failed",
    loginPath: "/login",
    statusLabels: {
      requested: "Requested",
      assigned: "Assigned",
      confirmed: "Confirmed",
      completed: "Completed",
      cancelled: "Cancelled",
    },
  },
};

export default carTrust;
